import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Mail, ShieldCheck, CreditCard, Truck, Heart, ArrowRight, Award, Leaf, Phone, MapPin } from 'lucide-react';
import { NewsletterSignup } from './NewsletterSignup';
export function Footer() {
  const currentYear = new Date().getFullYear();
  const footerLinks = {
    shop: [{
      name: 'Perros',
      path: '/productos?category=dog-food'
    }, {
      name: 'Gatos',
      path: '/productos?category=cat-food'
    }, {
      name: 'Snacks',
      path: '/productos?category=snacks'
    }, {
      name: 'Suplementos',
      path: '/productos?category=care'
    }, {
      name: 'Novedades',
      path: '/productos?sort=newest'
    }],
    company: [{
      name: 'Sobre Nosotros',
      path: '/nosotros'
    }, {
      name: 'Blog',
      path: '/blog'
    }, {
      name: 'Sostenibilidad',
      path: '/sostenibilidad'
    }, {
      name: 'Carreras',
      path: '/carreras'
    }, {
      name: 'Prensa',
      path: '/prensa'
    }],
    support: [{
      name: 'Ayuda y FAQ',
      path: '/faq'
    }, {
      name: 'Envíos y Devoluciones',
      path: '/envios'
    }, {
      name: 'Contacto',
      path: '/contacto'
    }, {
      name: 'Mi Cuenta',
      path: '/cuenta'
    }, {
      name: 'Seguimiento de Pedido',
      path: '/cuenta/pedidos'
    }],
    legal: [{
      name: 'Privacidad',
      path: '/privacidad'
    }, {
      name: 'Términos',
      path: '/terminos'
    }, {
      name: 'Cookies',
      path: '/cookies'
    }]
  };
  const trustBadges = [{
    icon: ShieldCheck,
    text: 'Garantía 30 Días',
    subtext: 'Devolución sin preguntas'
  }, {
    icon: Truck,
    text: 'Envío Gratis +49€',
    subtext: '24-48h península'
  }, {
    icon: Award,
    text: 'Calidad Certificada',
    subtext: 'FEDIAF & Human Grade'
  }, {
    icon: Leaf,
    text: 'Carbon Neutral',
    subtext: 'Huella compensada'
  }];
  return <footer className="bg-charcoal-900 text-white pt-24 pb-16 relative" data-id="element-1363">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-[0.02] pointer-events-none bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:24px_24px]" data-id="element-1364" />

      {/* Top Gradient Line */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-primary-600 via-secondary-500 to-primary-600 opacity-60" data-id="element-1365" />

      <div className="container-custom relative z-10" data-id="element-1366">
        {/* Trust Badges Bar */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-16 pb-16 border-b border-white/10" data-id="element-1367">
          {trustBadges.map((badge, index) => <div key={index} className="flex flex-col items-center text-center p-4 rounded-2xl bg-white/5 border border-white/10 hover:bg-white/10 transition-all group" data-id="element-1368">
              <div className="w-12 h-12 rounded-full bg-primary-500/20 flex items-center justify-center mb-3 group-hover:scale-110 transition-transform" data-id="element-1369">
                <badge.icon className="w-6 h-6 text-primary-400" data-id="element-1370" />
              </div>
              <h4 className="font-bold text-sm mb-1" data-id="element-1371">{badge.text}</h4>
              <p className="text-xs text-gray-400" data-id="element-1372">{badge.subtext}</p>
            </div>)}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 mb-20" data-id="element-1373">
          {/* Brand Column */}
          <div className="lg:col-span-4 space-y-8" data-id="element-1374">
            <Link to="/" className="inline-block group" data-id="element-1375">
              <div className="flex items-center gap-3" data-id="element-1376">
                <div className="text-white transition-transform duration-500 ease-out-expo group-hover:rotate-3 group-hover:scale-110" data-id="element-1377">
                  <svg width="48" height="48" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1378">
                    <path d="M20 36C26.6274 36 32 30.6274 32 24C32 17.3726 26.6274 12 20 12C13.3726 12 8 17.3726 8 24C8 30.6274 13.3726 36 20 36Z" fill="currentColor" fillOpacity="0.15" data-id="element-1379" />
                    <path d="M20 32C24.4183 32 28 28.4183 28 24C28 19.5817 24.4183 16 20 16C15.5817 16 12 19.5817 12 24C12 28.4183 15.5817 32 20 32Z" fill="currentColor" data-id="element-1380" />
                    <path d="M20 4C21.6569 4 23 5.34315 23 7C23 8.65685 21.6569 10 20 10C18.3431 10 17 8.65685 17 7C17 5.34315 18.3431 4 20 4Z" fill="currentColor" data-id="element-1381" />
                    <path d="M28.5 7C29.8807 7 31 8.11929 31 9.5C31 10.8807 29.8807 12 28.5 12C27.1193 12 26 10.8807 26 9.5C26 8.11929 27.1193 7 28.5 7Z" fill="currentColor" data-id="element-1382" />
                    <path d="M11.5 7C12.8807 7 14 8.11929 14 9.5C14 10.8807 12.8807 12 11.5 12C10.1193 12 9 10.8807 9 9.5C9 8.11929 10.1193 7 11.5 7Z" fill="currentColor" data-id="element-1383" />
                  </svg>
                </div>
                <div className="flex flex-col" data-id="element-1384">
                  <span className="text-3xl font-bold tracking-tight font-serif leading-none" data-id="element-1385">
                    Petiora
                  </span>
                  <span className="text-[10px] font-bold text-gray-400 uppercase tracking-[0.3em] mt-1 ml-0.5" data-id="element-1386">
                    Nutrición Clínica
                  </span>
                </div>
              </div>
            </Link>

            <p className="text-gray-400 leading-relaxed max-w-sm text-base font-light" data-id="element-1387">
              Revolucionando la salud de las mascotas con nutrición real, fresca
              y respaldada por la ciencia. Porque ellos son familia.
            </p>

            {/* Contact Info */}
            <div className="space-y-3" data-id="element-1388">
              <a href="tel:+34900123456" className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors group" data-id="element-1389">
                <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center group-hover:bg-white/10 transition-colors" data-id="element-1390">
                  <Phone className="w-5 h-5" data-id="element-1391" />
                </div>
                <div data-id="element-1392">
                  <div className="text-xs text-gray-500" data-id="element-1393">
                    Atención al Cliente
                  </div>
                  <div className="font-medium" data-id="element-1394">900 123 456</div>
                </div>
              </a>

              <a href="mailto:hola@petiora.com" className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors group" data-id="element-1395">
                <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center group-hover:bg-white/10 transition-colors" data-id="element-1396">
                  <Mail className="w-5 h-5" data-id="element-1397" />
                </div>
                <div data-id="element-1398">
                  <div className="text-xs text-gray-500" data-id="element-1399">Email</div>
                  <div className="font-medium" data-id="element-1400">hola@petiora.com</div>
                </div>
              </a>

              <div className="flex items-center gap-3 text-gray-400" data-id="element-1401">
                <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center" data-id="element-1402">
                  <MapPin className="w-5 h-5" data-id="element-1403" />
                </div>
                <div data-id="element-1404">
                  <div className="text-xs text-gray-500" data-id="element-1405">Sede Central</div>
                  <div className="font-medium" data-id="element-1406">Barcelona, España</div>
                </div>
              </div>
            </div>

            {/* Social Media */}
            <div className="flex gap-3" data-id="element-1407">
              {[{
              name: 'Instagram',
              icon: Instagram,
              url: '#'
            }, {
              name: 'Facebook',
              icon: Facebook,
              url: '#'
            }, {
              name: 'Twitter',
              icon: Twitter,
              url: '#'
            }].map(social => <a key={social.name} href={social.url} className="w-11 h-11 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:bg-primary-600 hover:border-primary-600 hover:scale-110 transition-all duration-300 group" aria-label={social.name} data-id="element-1408">
                  <social.icon className="w-5 h-5 group-hover:scale-110 transition-transform" data-id="element-1409" />
                </a>)}
            </div>
          </div>

          {/* Links Columns */}
          <div className="lg:col-span-2 space-y-6" data-id="element-1410">
            <h4 className="font-bold text-lg font-serif text-white" data-id="element-1411">Tienda</h4>
            <ul className="space-y-3" data-id="element-1412">
              {footerLinks.shop.map(link => <li key={link.path} data-id="element-1413">
                  <Link to={link.path} className="text-gray-400 hover:text-white hover:translate-x-1 transition-all duration-300 inline-flex items-center gap-2 text-sm group" data-id="element-1414">
                    <span className="w-1 h-1 rounded-full bg-primary-500 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1415"></span>
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div className="lg:col-span-2 space-y-6" data-id="element-1416">
            <h4 className="font-bold text-lg font-serif text-white" data-id="element-1417">
              Compañía
            </h4>
            <ul className="space-y-3" data-id="element-1418">
              {footerLinks.company.map(link => <li key={link.path} data-id="element-1419">
                  <Link to={link.path} className="text-gray-400 hover:text-white hover:translate-x-1 transition-all duration-300 inline-flex items-center gap-2 text-sm group" data-id="element-1420">
                    <span className="w-1 h-1 rounded-full bg-primary-500 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1421"></span>
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Newsletter Column */}
          <div className="lg:col-span-4 space-y-6" data-id="element-1422">
            <div className="bg-gradient-to-br from-white/10 to-white/5 rounded-3xl p-8 border border-white/10 backdrop-blur-sm relative overflow-hidden" data-id="element-1423">
              <div className="absolute top-0 right-0 w-32 h-32 bg-primary-500/10 rounded-full blur-3xl" data-id="element-1424"></div>

              <div className="relative z-10" data-id="element-1425">
                <h4 className="font-bold text-xl font-serif text-white mb-3" data-id="element-1426">
                  Únete a la Manada
                </h4>
                <p className="text-gray-400 text-sm mb-6 leading-relaxed" data-id="element-1427">
                  Recibe consejos veterinarios, ofertas exclusivas y novedades
                  sobre nutrición directamente en tu inbox.
                </p>

                <NewsletterSignup data-id="element-1428" />

                <div className="pt-6 flex items-center gap-2 text-xs text-gray-500" data-id="element-1429">
                  <ShieldCheck className="w-4 h-4 text-emerald-400" data-id="element-1430" />
                  <span data-id="element-1431">Tus datos están 100% seguros. Sin spam.</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 space-y-6" data-id="element-1432">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-1433">
            <div className="text-gray-500 text-sm font-medium" data-id="element-1434">
              © {currentYear} Petiora. Todos los derechos reservados.
            </div>

            <div className="flex flex-wrap justify-center gap-6 text-sm" data-id="element-1435">
              {footerLinks.legal.map(link => <Link key={link.path} to={link.path} className="text-gray-500 hover:text-white transition-colors" data-id="element-1436">
                  {link.name}
                </Link>)}
            </div>

            <div className="flex items-center gap-4" data-id="element-1437">
              <div className="flex items-center gap-2 text-gray-500" data-id="element-1438">
                <CreditCard className="w-5 h-5" data-id="element-1439" />
                <span className="text-xs" data-id="element-1440">Pago Seguro</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10" data-id="element-1441">
                <span className="text-xs text-gray-400" data-id="element-1442">Hecho con</span>
                <Heart className="w-3 h-3 text-rose-500 fill-current animate-pulse-slow" data-id="element-1443" />
                <span className="text-xs text-gray-400" data-id="element-1444">en España</span>
              </div>
            </div>
          </div>

          {/* Payment Methods */}
          <div className="flex flex-col sm:flex-row justify-center items-center gap-4 pt-6 border-t border-white/5 pb-2" data-id="element-1445">
            <span className="text-xs text-gray-500" data-id="element-1446">Métodos de pago:</span>
            <div className="flex flex-wrap justify-center gap-3 opacity-50" data-id="element-1447">
              {['Visa', 'Mastercard', 'PayPal', 'Apple Pay'].map(method => <div key={method} className="px-3 py-1.5 bg-white/10 rounded text-xs font-medium" data-id="element-1448">
                  {method}
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </footer>;
}